import Tagify from '@yaireo/tagify'

var inputElem = document.querySelector('#mapped_skus')
var tagify = new Tagify(inputElem);